<script setup lang="ts">
import { useRouter } from 'vue-router';
import { DtBtn } from '@/design-system';
import { enablePushNotifications, pushState, pushLabels, pushMessage } from '@/api/push';
const router = useRouter();
</script>

<template>
  <div class="push-control">
    <p role="status">
      Notificações: {{ pushLabels[pushState] }}
    </p>
    <p
      v-if="pushMessage !== null"
      role="status"
    >
      Há uma atualização no portal. Consulte seus atendimentos.
    </p>
    <DtBtn
      v-if="pushMessage !== null"
      @click="router.push(pushMessage.route)"
    >
      Abrir atualização
    </DtBtn>
    <DtBtn
      v-if="pushState !== 'enabled' && pushState !== 'denied' && pushState !== 'unsupported' && pushState !== 'unconfigured'"
      :disabled="pushState === 'busy' || pushState === 'cleaning'"
      @click="enablePushNotifications()"
    >
      Ativar notificações
    </DtBtn>
  </div>
</template>

<style scoped>
.push-control { display: grid; gap: var(--dt-space-xs); padding: var(--dt-space-sm); }
.push-control p { margin: 0; color: var(--dt-text-secondary); font-size: var(--dt-font-size-sm); }
</style>